export enum LLMConfigFormFields {
  KEY_VALUES = 'keyValuePropositions',
  ATTRIBUTES = 'importantProductAttributeCodes',
}

export type TLLMConfigFormValues = {
  [LLMConfigFormFields.KEY_VALUES]: string[];
  [LLMConfigFormFields.ATTRIBUTES]?: string[];
};
